import { create } from "zustand";

const DISMISSED_ALERTS_KEY = "dismissed_system_alerts";

function getDismissedAlerts(): number[] {
  if (typeof window === "undefined") {
    return [];
  }
  try {
    const stored = localStorage.getItem(DISMISSED_ALERTS_KEY);
    return stored ? JSON.parse(stored) : [];
  } catch {
    return [];
  }
}

function saveDismissedAlert(alertId: number): void {
  try {
    const dismissed = getDismissedAlerts();
    if (!dismissed.includes(alertId)) {
      dismissed.push(alertId);
      localStorage.setItem(DISMISSED_ALERTS_KEY, JSON.stringify(dismissed));
    }
  } catch {
    // Ignore localStorage errors
  }
}

type SystemAlertStore = {
  dismissedAlertIds: number[];
  dismissAlert: (alertId: number) => void;
};

export const useSystemAlertStore = create<SystemAlertStore>((set) => ({
  // Initialize synchronously from localStorage to avoid flash
  dismissedAlertIds: getDismissedAlerts(),

  dismissAlert: (alertId: number) => {
    saveDismissedAlert(alertId);
    set((state) => ({
      dismissedAlertIds: [...state.dismissedAlertIds, alertId],
    }));
  },
}));
